<template>
    <div class="pro-main-container-bloc">
        <form-container
                :form-title="formTitle"
                :code="code"
                :loaded="loaded"
                :logo="logo"
                :no-header="noHeader"
                :txt-intro="txtIntro"
                :cgu="cgu"
                :organism="organism"
                :referent="referent"
                :sit="false">
        </form-container>
    </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex"
import PhoneNumber from "awesome-phonenumber"
import hash from "object-hash"
import _ from "lodash"

import CmajFormHeader from "./CmajFormHeader.vue"
import CmajFormError from "./CmajFormError.vue"
import CmajFormTabulations from "./CmajFormTabulations.vue"
import CmajFormMenu from "./CmajFormMenu.vue"
import CmajFormFooter from "./CmajFormFooter.vue"
import CmajFormCgu from "./CmajFormCgu.vue"
import CopyrightModal from "./modals/CopyrightModal.vue";
import OpeningPeriodModal from "./modals/OpeningPeriodModal.vue"
import PricePeriodModal from "./modals/PricePeriodModal.vue"
import HelpModal from "./modals/HelpModal.vue"
import FormContainer from "./FormContainer.vue"

export default {
    name: "CmajForm",
    components: {
        FormContainer,
        CmajFormCgu,
        CmajFormFooter,
        HelpModal,
        PricePeriodModal,
        OpeningPeriodModal,
        CopyrightModal,
        CmajFormTabulations,
        CmajFormError,
        CmajFormHeader,
        CmajFormMenu
    },
    data() {
        return {
            token: null,
            code: null,
            loaded: false,
            referent: {emailable: {}},
            logo: {},
            cgu: null,
            organism: null,
            txtIntro: {},
            formTitle: null,
            comToParses: [],
            dayToParses: [],
            suggestedLocalisation: null,
            interval: null,
            noHeader: false,
        }
    },
    methods: {
        ...mapMutations('webFormStyle', ['setFieldsColor', 'setTitlesColor', 'setPrimaryColor',
            'setBackGroundColor', 'setFontFamily']),
        ...mapMutations('web_form', [
            'resetState', 'setProvider', 'setFields', 'setFamilyElements', 'setContact', 'setSubmitted',
            'setCapacities', 'setRoomRenting', 'setCategoryFamilies', 'setSuggestedMedias', 'pushSuggestedMedias',
            'pushSuggestedCommunications', 'setSourcesLoaded', 'setSuggestedAddress', 'setSuggestedCommune',
            'setSuggestedOpeningDays', 'setExtra', 'setSuggestedH24', 'setAiEnabled', 'setId', 'setIsDirty',
            'setBaseOpeningPeriods', 'setBasePricePeriods', 'setBaseProviderHash', 'setInitProvider',
            'formatPricePeriods', 'formatContents', 'formatCommunications', 'generateTabulations',
            'generateTabActiveRanges', 'handleSpecificTabulation', 'orderTabulations', 'setBooleanFieldValues',
            'setNumericFieldValues', 'setOrigin', 'setDateFieldValues', 'setCurrency', 'setAspect',
            'setEditedTabulations', 'setAllSuggestedMediasLoaded', 'setAccountTisType',
        ]),
        ...mapMutations('forbiddenCriteria', ['setForbiddenCriteria']),
        getProvider(resourcesPromise = Promise.resolve()) {
            this.setIsDirty(false)
            this.setBaseProviderHash(null)

            return Promise.all([
                this.$http.get('webform/' + this.token),
                resourcesPromise
            ]).then(([res]) => {
                if (res.body.success) {
                    const campaign = res.body.data.campaign
                    const answer = res.body.data.answer
                    const config = res.body.data.configurations

                    if(campaign) {
                        this.setAspect(campaign.aspect)
                    }

                    this.cgu = res.body.data.cgu
                    this.organism = res.body.data.organism
                    this.logo = config.logo
                    this.formTitle = config.formTittle
                    this.referent = res.body.data.referent
                    this.setEditedTabulations(res.body.data.editedTabulations)

                    this.setProvider(res.body.data.provider)
                    this.setForbiddenCriteria(res.body.data.forbiddenCriteria)
                    this.formatPricePeriods()
                    this.formatContents(this.languages)
                    this.formatCommunications(this.communicationTypes)
                    this.setFamilyElements(res.body.data.referential)
                    this.setContact(res.body.data.contact)
                    this.setRoomRenting(res.body.data.provider.room_renting)
                    this.setCategoryFamilies(res.body.data.categoryFamilies)
                    this.setAiEnabled(res.body.data.aiEnabled)
                    this.setId(res.body.data.provider.id)
                    this.setCapacities(this.getFamilyByCode('Capacites'))
                    this.setCurrency(res.body.data.currency)
                    this.setBooleanFieldValues()
                    this.setNumericFieldValues()
                    this.setDateFieldValues()
                    this.setAccountTisType(res.body.data.accountTisType)

                    this.txtIntro = res.body.data.txtIntro

                    if (answer !== null) {
                        let contact = {
                            first_name: answer.first_name,
                            last_name: answer.last_name,
                            email: answer.email,
                            id: res.body.data.contact.id,
                            token: res.body.data.contact.token
                        }

                        this.setExtra(answer.extra)
                        this.setContact(contact)
                    }

                    if (this.user === null || this.user === undefined) {
                        this.$http.get('webform/opened/' + this.token)
                    }

                    this.loadCustomCss(res.body.data.webFormStyle)

                    this.generateTabulations(false)
                    this.handleSpecificTabulation()
                    this.orderTabulations()

                    this.loaded = true

                    setTimeout(() => {
                        this.generateTabActiveRanges()
                    }, 1000)
                }

                if (res.body.code !== null && res.body.code !== undefined) {
                    this.code = res.body.code

                    if (this.code === 'SAVING_DRAFT') {
                        this.interval = setInterval(this.getWebFormState, 3000)
                    }
                }
            })
        },
        getFields() {
            return this.$http.get('webform/fields/' + this.token).then(res => {
                if (res.body.success) {
                    this.setFields(res.body.data.fields)
                }
            })
        },
        getInitData(providerPromise = Promise.resolve()) {
            return Promise.all([
                this.$http.get('webform/init-data/' + this.token),
                providerPromise
            ]).then(([res]) => {
                if (res.body.success) {
                    let initData = res.body.data.initProvider

                    if (initData === null) {
                        initData = JSON.parse(JSON.stringify(this.provider))
                    }

                    this.setBasePeriods(initData)
                }
            })
        },
        setBasePeriods(initProvider) {
            setTimeout(() => {
                this.setInitProvider(initProvider)
                this.setBasePricePeriods()
                this.setBaseOpeningPeriods()
            }, 2000)
        },
        fetchExternalMedias(source) {
            let payload = {
                source: source,
                token: this.token,
                mediaLimit: 3,
            }

            return this.$http.post('online-presence/medias', payload).then(res => {
                let medias = res.body.data.medias
                let communications = res.body.data.communications
                let localisation = res.body.data.localisation
                let openingDays = res.body.data.openingDays ?? []
                let h24 = res.body.data.h24

                if (h24) {
                    this.setSuggestedH24(h24)
                }

                if(medias.length < 3 && source === 'GOOGLE') {
                    this.setAllSuggestedMediasLoaded(true)
                }

                medias = medias.map(media => {
                    if (media.thumbnail_url === null) {
                        media.thumbnail_url = media.origin_url
                    }

                    return media
                })

                this.comToParses = [...this.comToParses, ...communications]
                this.dayToParses = [...this.dayToParses, ...openingDays]

                this.pushSuggestedMedias(medias)

                if (localisation !== null) {
                    this.suggestedLocalisation = localisation
                }
            })
        },
        sortSuggestedMedias() {
            let sorted = this.suggestedMedias.sort((media1, media2) => {
                return media2.quality - media1.quality
            })

            this.setSuggestedMedias(sorted.slice(0, 10))
        },
        parseSuggestedCommunications() {
            this.comToParses.forEach(com => {
                let hasSuggestion = this.suggestedCommunications.find(suggestedCom => suggestedCom.type.name === com.type.name)

                if (hasSuggestion === undefined && this.provider !== null) {
                    let hasSameValue = false

                    this.provider.communications.forEach(providerCom => {
                        if (providerCom.type.name === com.type.name && !hasSameValue) {
                            if (providerCom.type.name === 'PHONE' || providerCom.type.name === 'FAX') {
                                let phone1 = com.value !== null ?
                                    new PhoneNumber(com.value, 'FR').getNumber() : null
                                let phone2 = providerCom.value !== null ?
                                    new PhoneNumber(providerCom.value, 'FR').getNumber() : null

                                hasSameValue = phone1 === phone2
                            } else if (['WEBSITE', 'TRIPADVISOR', 'YELP', 'FACEBOOK', 'GOOGLE', 'YOUTUBE', 'INSTAGRAM', 'LINKEDIN', 'TIKTOK', 'WEBSITE_EN']
                                .includes(providerCom.type.name)) {
                                let url1 = com.value ?? ''

                                url1 = url1.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "")

                                let url2 = providerCom.value ?? ''

                                url2 = url2.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "")

                                if (url1.charAt(url1.length - 1) === '/') {
                                    url1 = url1.substr(0, url1.length - 1)
                                }

                                if (url2.charAt(url2.length - 1) === '/') {
                                    url2 = url2.substr(0, url2.length - 1)
                                }

                                if(com.type.name === 'GOOGLE') {
                                   let index1 = url1.indexOf('&')
                                    if(index1 >= 0) {
                                        url1 = url1.slice(0, index1)
                                    }

                                    let index2 = url2.indexOf('&')
                                    if(index2 >= 0) {
                                        url2 = url2.slice(0, index2)
                                    }
                                } else if(['FACEBOOK', 'INSTAGRAM'].includes(com.type.name)) {
                                    let index1 = url1.indexOf('?')
                                    if(index1 >= 0) {
                                        url1 = url1.slice(0, index1 - 1)
                                    }

                                    let index2 = url2.indexOf('?')
                                    if(index2 >= 0) {
                                        url2 = url2.slice(0, index2 - 1)
                                    }
                                }

                                hasSameValue = url1 === url2
                            } else if (providerCom.value === com.value) {
                                hasSameValue = true
                            }
                        }
                    })

                    if (!hasSameValue) {
                        this.pushSuggestedCommunications([com])
                    }
                }
            })
        },
        parseSuggestedLocalisation() {
            if (this.provider !== undefined && this.provider !== null) {
                let lowerAddr = this.provider.localisation.address !== null ? this.provider.localisation.address.toLocaleLowerCase() : null

                if (this.suggestedLocalisation !== null &&
                    this.suggestedLocalisation.address !== null &&
                    this.suggestedLocalisation.address.toLocaleLowerCase() !== lowerAddr) {

                    let lowerSuggestAddr = this.suggestedLocalisation.address.toLocaleLowerCase()
                    lowerSuggestAddr = lowerSuggestAddr.replace(',', '')
                    lowerAddr = lowerAddr.replace(",", "")

                    if (lowerSuggestAddr !== lowerAddr) {
                        this.setSuggestedAddress(this.suggestedLocalisation.address)
                    }
                }

                if (this.suggestedLocalisation !== null &&
                    this.suggestedLocalisation.commune !== null &&
                    this.suggestedLocalisation.commune.id !== this.provider.localisation.commune.id) {

                    this.setSuggestedCommune(this.suggestedLocalisation.commune)
                }
            }
        },
        parseSuggestedOpeningDays() {
            if (this.provider !== null) {
                if (this.provider.opening_periods.length === 0) {
                    this.setSuggestedOpeningDays(this.dayToParses)
                } else {
                    let period = this.provider.opening_periods[0]
                    let hasDiffs = false

                    this.dayToParses.forEach(dayToParse => {
                        const day = period.opening_days.find(openingDay => openingDay.day_of_week === dayToParse.day_of_week)

                        if (dayToParse.opening_hours.length === 0) {
                            dayToParse.opening_hours.push({ open: null, close: null})
                        }

                        if (day !== null && day !== undefined) {
                            hasDiffs = (day.closed !== dayToParse.closed ||
                                hash(this.cleanEmptyHours(day.opening_hours)) !==
                                hash(this.cleanEmptyHours(dayToParse.opening_hours))) || hasDiffs
                        }
                    })

                    if (hasDiffs) {
                        this.dayToParses.forEach(dayToParse => {
                            this.setSuggestedOpeningDays([dayToParse])
                        })
                    }
                }
            }
        },
        cleanEmptyHours(hours) {
            let clearedHours = hours !== undefined ? JSON.parse(JSON.stringify(hours)) : []

            clearedHours.forEach((hour, index) => {
                if (hour.open === null && hour.close === null) {
                    clearedHours.splice(index, 1)
                }
            })

            return clearedHours
        },
        loadCustomCss(attributes) {
            if (this.$route.query.preview === undefined && attributes !== null) {
                this.setFontFamily(this.aspect === null ? attributes.font_family : attributes.casp_font_family)
                this.setPrimaryColor(this.aspect === null ?
                  attributes.primary_color : attributes.casp_primary_color)
                this.setTitlesColor(this.aspect === null ? attributes.title_color : attributes.casp_title_color)
                this.setBackGroundColor(this.aspect === null ?
                  attributes.background_color : attributes.casp_background_color)
                this.setFieldsColor(this.aspect === null ? attributes.field_color : attributes.casp_field_color)
            }
        },
        getWebFormState() {
            this.$http.get('webform/state/' + this.token).then(res => {
                if (res.body.data.state.code !== 'SAVING_DRAFT') {
                    clearInterval(this.interval)

                    this.getProvider(this.resourcesPromise)
                }
            })
        }
    },
    computed: {
        ...mapState('web_form', ['provider', 'suggestedMedias', 'suggestedCommunications', 'baseProviderHash', 'aspect']),
        ...mapState('account', ['user']),
        ...mapState('resource', ['languages', 'communicationTypes']),
        ...mapState('webFormStyle', ['fontFamily', 'primaryColor', 'titlesColor', 'fieldsColor', 'backGroundColor']),
        ...mapGetters('web_form', ['getFamilyByCode'])
    },
    watch: {
        provider: {
            handler: _.debounce(function () {
                if (this.baseProviderHash === null) {
                    this.setBaseProviderHash(hash(this.provider))
                }

                this.setIsDirty(this.baseProviderHash !== hash(this.provider))
            }, 500),
            deep: true
        }
    },
    created() {
        window.Intercom('shutdown')
        window.Intercom('hide')

        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
        })

        this.resetState()

        this.token = this.$route.params.pathMatch.split('/')[1]
        this.noHeader = this.$route.query.hidden && this.$route.query.hidden.includes('HEADER')

        const languagesPromise = this.$store.dispatch('resource/fetchLanguages')
        const communicationTypesPromise = this.$store.dispatch('resource/fetchCommunicationTypes')
        this.$store.dispatch('resource/fetchProfessions')
        this.$store.dispatch('resource/fetchCurrencies')

        const promise2 = this.getFields()
        this.resourcesPromise = Promise.all([languagesPromise, communicationTypesPromise, promise2])

        const promise1 = this.getProvider(this.resourcesPromise)
        this.getInitData(promise1)

        const promise3 = this.fetchExternalMedias('GOOGLE').catch(() => {})
        const promise4 = this.fetchExternalMedias('GOOGLE_CUSTOM').catch(() => {})

        Promise.all([promise1, promise3, promise4]).then(() => {
          //  this.sortSuggestedMedias()
            this.setSourcesLoaded(true)
            this.parseSuggestedCommunications()
            this.parseSuggestedLocalisation()
            this.parseSuggestedOpeningDays()
        })

        if (this.$route.query.origin) {
            this.setOrigin(this.$route.query.origin)
        }

        window.onbeforeunload = () => {
            return true
        }
    },
    beforeDestroy() {
        window.onbeforeunload = null
    }
}
</script>